import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "period-controller"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "title"
}, "Evolution", -1);
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["id", "innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_view_export_dropdown = _resolveComponent("view-export-dropdown");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_date_value = _resolveComponent("date-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_boxed_value = _resolveComponent("boxed-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_value_element = _resolveComponent("value-element");
  const _component_dotted_value = _resolveComponent("dotted-value");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_compound_table = _resolveComponent("compound-table");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_view_export_dropdown, {
    onCsvDownload: $options.downloadPerformancePeriodCSV,
    onGoogleSheetDownload: $options.downloadPerformanceGoogleSheet,
    onCsvCopy: $options.copyPerformancePeriodCSV
  }, null, 8, ["onCsvDownload", "onGoogleSheetDownload", "onCsvCopy"]), _renderSlot(_ctx.$slots, "period-selector")]), _createVNode(_component_wrap_table_with_show_more, {
    modelValue: $options.period_pager,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $options.period_pager = $event),
    period: _ctx.period
  }, {
    default: _withCtx(() => [_createVNode(_component_compound_table, {
      class: "ppc-performance-period-compound",
      loading: $props.loading,
      fields: $options.fields,
      errorOccurred: _ctx.periodTable.errorOccurred,
      onRetry: _cache[2] || (_cache[2] = $event => _ctx.$emit('refresh'))
    }, {
      header: _withCtx(() => [_createTextVNode(_toDisplayString($options.periodTitle), 1)]),
      "group-by-title": _withCtx(() => []),
      actions: _withCtx(() => []),
      table: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: _normalizeClass(['lite-table lite-table-hoverable performance-period-table period-table', {
          ['show-shadow']: $data.showShadow
        }]),
        items: $options.items,
        fields: $options.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        "sticky-header": true,
        tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
        onScroll: _cache[0] || (_cache[0] = $event => $data.showShadow = $event.target.scrollLeft > 0),
        onRowClicked: _cache[1] || (_cache[1] = item => _ctx.handleRowClicked(item, $options.handleDateReset, $options.handleDateClick, 'period_agg'))
      }, {
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          styles: {
            justifyContent: col.field.justify,
            ...col.field?.thStyle
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `period-table-${col?.label}`,
            style: {
              width: '100%'
            }
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: col?.label
            }, null, 8, _hoisted_3)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              id: `period-table-${col?.label}`,
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_4)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["styles"])]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.period_agg,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ...$options.activateDateValueStyles(row)
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(spend)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 4
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}spend_evol`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}spend_evol`],
                color: color,
                "show-sign": "",
                charCount: $options.maxCharCount.percentage?.[`${_ctx.evolCategory[_ctx.periodCategory]}spend_evol`]
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              tight: "",
              align: "left",
              value: row.item?.spend,
              color: "var(--market-600)",
              min: $options.minMax?.spend?.min,
              max: $options.minMax?.spend?.max,
              loading: $props.loading,
              width: $options.maxCharCount?.currency?.spend
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.spend,
                charCount: $options.maxCharCount?.currency?.spend
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading", "width"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(sponsored_sales)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 4
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}sponsored_sales_evol`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`${_ctx.evolCategory[_ctx.periodCategory]}sponsored_sales_evol`],
                color: color,
                "show-sign": "",
                charCount: $options.maxCharCount.percentage?.[`${_ctx.evolCategory[_ctx.periodCategory]}sponsored_sales_evol`]
              }, null, 8, ["value", "color", "charCount"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              tight: "",
              align: "left",
              value: row.item?.sponsored_sales,
              color: "var(--market-400)",
              min: $options.minMax?.sponsored_sales?.min,
              max: $options.minMax?.sponsored_sales?.max,
              loading: $props.loading,
              width: $options.maxCharCount?.currency?.sponsored_sales
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.sponsored_sales,
                charCount: $options.maxCharCount?.currency?.sponsored_sales
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading", "width"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(TACOS)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.TACOS,
          background: "#EBD4F7",
          borderColor: "#CD93EB",
          min: $options.minMax?.TACOS?.min,
          max: $options.minMax?.TACOS?.max,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.TACOS
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(CVR)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorsBasedOnRange(row.item?.CVR, $data.CVR_HEATMAP_COLORS),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.CVR,
            limit: 0.1
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["bgColor", "loading"])]),
        "cell(ROAS)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
          value: row.item?.ROAS,
          background: "#E6E9FE",
          borderColor: "#D8DCFD",
          min: $options.minMax?.ROAS?.min,
          max: $options.minMax?.ROAS?.max,
          loading: $props.loading,
          align: "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_number_value, {
            styles: {
              padding: 0
            },
            value: row.item?.ROAS,
            precision: 1
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"])]),
        "cell(units_sold_clicks_14_d)": _withCtx(row => [_createVNode(_component_number_value, {
          value: row.item?.units_sold_clicks_14_d,
          loading: $props.loading
        }, null, 8, ["value", "loading"])]),
        "cell(clicks)": _withCtx(row => [_createVNode(_component_number_value, {
          value: row.item?.clicks,
          loading: $props.loading
        }, null, 8, ["value", "loading"])]),
        "cell(best_position)": _withCtx(row => [_createVNode(_component_dotted_value, {
          align: 'center',
          color: $options.getColorsBasedOnRange(row.item?.best_position, $data.BEST_POSITION_HEATMAP_COLORS),
          value: row.item?.best_position,
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_value_element, {
            value: row.item?.best_position
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["color", "value", "loading"])]),
        "cell(CPC)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorForDecile(row.item?.CPC, $options.minMax?.CPC?.min, $options.minMax?.CPC?.max, $data.CPC_DECILE_COLORS),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.CPC,
            precision: 2,
            config: _ctx.currencyConfig
          }, null, 8, ["value", "config"])]),
          _: 2
        }, 1032, ["bgColor", "loading"])]),
        "cell(CTR)": _withCtx(row => [_createVNode(_component_boxed_value, {
          bgColor: $options.getColorsBasedOnRange(row.item?.CTR, $data.CVR_HEATMAP_COLORS),
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.CTR,
            limit: 0.1,
            precision: 2
          }, null, 8, ["value"])]),
          _: 2
        }, 1032, ["bgColor", "loading"])]),
        "cell(impressions)": _withCtx(row => [_createVNode(_component_number_value, {
          value: row.item?.impressions,
          loading: $props.loading
        }, null, 8, ["value", "loading"])]),
        _: 1
      }, 8, ["class", "items", "fields", "tbodyTrClass"])]),
      _: 1
    }, 8, ["loading", "fields", "errorOccurred"])]),
    _: 1
  }, 8, ["modelValue", "period"])], 64);
}